import { invariant, isAliasedPropSchema, isPropSchema } from '../utils/utils';
import { _defaultPrimitiveProp } from '../constants';
import { serialize } from '../core/serialize';
import { ChainedSchema } from './general/ChainedSchema';
import { SerializrType_primitive } from './inner/primitive';
import { DeserializeAttributeContext } from '../context/DeserializeAttributeContext';
class SerializrType_list extends ChainedSchema {
    serializer({ value: array }) {
        invariant(array && 'length' in array && 'map' in array, 'expected array (like) object');
        if (this.parentSchema instanceof SerializrType_primitive) {
            return array.map(value => value);
        }
        return array.map(item => serialize(item));
    }
    deserializer(context) {
        const jsonArray = context.json;
        const oldArray = context.oldValue || [];
        if (!Array.isArray(jsonArray)) {
            throw '[serializr] expected JSON array';
        }
        const newArray = oldArray;
        const itemsToReuse = oldArray.slice();
        if (oldArray.length > 0) {
            // do not change/write initial array in computed deserialize
            oldArray.length = 0;
        }
        for (let i = 0; i < jsonArray.length; i++) {
            const itemToMap = jsonArray[i];
            let itemPropSchema = this.parentSchema;
            if (typeof itemPropSchema === 'function') {
                itemPropSchema = itemPropSchema(itemToMap, context.objectContext);
            }
            // try to reuse from existing
            let existing;
            if (itemToMap && itemToMap.id) {
                const foundIndex = itemsToReuse.findIndex((item) => item && item.id === itemToMap.id && item.type === itemToMap.type);
                if (foundIndex > -1) {
                    existing = itemsToReuse[foundIndex];
                    itemsToReuse.splice(foundIndex, 1);
                }
                else {
                    // console.log('COULD NOT REUSE!');
                }
            }
            const newContext = new DeserializeAttributeContext({ ...context, json_overwrite: itemToMap });
            newContext.oldValue = existing;
            newArray[i] = itemPropSchema.deserializer(newContext);
        }
        return newArray;
    }
}
export function list(propSchemaRaw) {
    let propSchema = propSchemaRaw;
    if (typeof propSchema !== 'function') {
        propSchema = propSchema || _defaultPrimitiveProp;
        invariant(isPropSchema(propSchema), 'expected prop schema as first argument');
        invariant(!isAliasedPropSchema(propSchema), 'provided prop is aliased, please put aliases first');
    }
    return new SerializrType_list(propSchema);
}
